import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/admin/add-client/[id]/online-courses-and-documents/page";

export const Route = createFileRoute(
  "/admin/add-client/$clientId/online-courses-and-documents",
)({
  component: Page,
});
